<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>attach_file</mat-icon></div>
    <div class="fdl-header-text">
      <h2 class="cf-dlg-title">Importar cuadro de amortización</h2>
      <p class="cf-dlg-subtitle">{{ descripcion || 'Fichero Excel (.xlsx)' }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="closeDialog()" [disabled]="loadingFile" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="loadingFile" message="Subiendo cuadro de amortización…"></app-loading-state>

  <ng-container *ngIf="!loadingFile">
    <div class="cf-dlg-body">
      <div class="fdl-alert">
        <mat-icon>info</mat-icon>
        <span>Selecciona el cuadro de amortización en formato Excel (.xlsx). Si ya había uno adjunto, se sustituirá por el nuevo.</span>
      </div>

      <div class="fdl-alert fdl-alert--error" *ngIf="errorMessage">
        <mat-icon>error</mat-icon>
        <span>{{ errorMessage }}</span>
      </div>

      <div class="cf-dlg-upload-zone fdl-upload-zone">
        <label class="cf-dlg-upload-btn" for="financiacion-propia-attachment-input">
          <mat-icon>file_upload</mat-icon>
          Seleccionar Excel
        </label>
      </div>
      <input id="financiacion-propia-attachment-input" class="fdl-upload-input" type="file" accept=".xlsx" (change)="uploadFile($event)">
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cerrar</button>
    </div>
  </ng-container>
</div>
